"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ILabel = void 0;
var utils_1 = require("../../../utils");
var default_label_hue_1 = require("../../default-values/default-label-hue");
var default_label_name_1 = require("../../default-values/default-label-name");
var id_type_1 = require("../id-type");
exports.ILabel = (0, utils_1.IRecord)({
    id: (0, id_type_1.defaultIdMaker)(),
    name: default_label_name_1.defaultLabelName,
    hue: default_label_hue_1.defaultHue
});
